import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/reset.css';
import './styles/typography.css';
import './styles/animations.css';
import './styles/utilities.css';
import './styles/cards.css';
import './styles/forms.css';
import './styles/buttons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GA_TRACKING_ID, sendWebVitalsToGA } from './utils/analytics';

// Inject Google Analytics script if tracking ID is configured
if (GA_TRACKING_ID) {
  // Create and inject the gtag.js script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    send_page_view: false // We'll track page views manually on route changes
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Send Web Vitals to Google Analytics
reportWebVitals(sendWebVitalsToGA);

